import { quickSort } from "./sortArray";
import { initialTerm } from "../types/constants";
export function collectUniqueValues(tariffs) {
    var uniquePeriods = [];
    var minSum = Infinity;
    var maxSum = -Infinity;
    // Собираем уникальные периоды и находим минимальную и максимальную суммы
    tariffs.forEach(function (tariff) {
        if (tariff.maxSum > 0 && tariff.allowOnline === 1) {
            tariff.periods.forEach(function (term) { return uniquePeriods.push({
                value: term,
                vr: tariff.vr,
            }); });
            minSum = Math.min(minSum, tariff.minSum);
            maxSum = Math.max(maxSum, tariff.maxSum);
        }
    });
    // Убираем дубли в массиве сроков
    uniquePeriods = deduplicatePeriods(uniquePeriods);
    // Генерация массива сумм с шагами
    var sumRange = [];
    for (var sum = minSum; sum <= maxSum; sum += 1000) {
        if (sum > 0) {
            sumRange.push(sum);
        }
    }
    return {
        periods: sortTerm(uniquePeriods),
        sumRange: quickSort(sumRange),
        daysPay: [],
    };
}
function deduplicatePeriods(periods) {
    var result = [];
    var seen = new Set();
    for (var _i = 0, periods_1 = periods; _i < periods_1.length; _i++) {
        var period = periods_1[_i];
        var groupKey = function (vr) {
            if (vr === 2)
                return "months";
            if (vr === 0 || vr === 1)
                return "days";
            return "vr-".concat(vr);
        };
        var key = "".concat(period.value, "-").concat(groupKey(period.vr));
        if (!seen.has(key)) {
            seen.add(key);
            result.push(period);
        }
    }
    return result;
}
function convertToDays(item) {
    if (item.vr === 2) {
        return item.value * 30;
    }
    return item.value;
}
// Функция сортировки с учетом конвертации
function sortTerm(terms) {
    return terms.sort(function (a, b) { return convertToDays(a) - convertToDays(b); });
}
/**
 * Поиск наибольшего срока
 * @param terms
 */
export function findMaxTerm(terms) {
    if (terms.length <= 0)
        return initialTerm;
    return terms.reduce(function (max, current) {
        var currentDays = convertToDays(current);
        return currentDays > convertToDays(max) ? current : max;
    });
}
